require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insightsdesigntwo.json") })
        }
      }, "path---insightsdesigntwo");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insightsdesigntwo!./.cache/json/insightsdesigntwo.json
// module id = 1180
// module chunks = 231608221292675